import { z } from 'zod';
import { PROTOCOL_VERSION } from './constants.js';
export const Vec3Schema = z.object({
    x: z.number(),
    y: z.number(),
    z: z.number(),
});
// Client -> Server schemas
export const JoinRoomMessageSchema = z.object({
    version: z.string().default(PROTOCOL_VERSION),
    type: z.literal('join_room'),
    roomId: z.string().optional(),
    playerName: z.string().trim().min(1).max(24),
    color: z.string().regex(/^#[0-9a-fA-F]{6}$/).optional(),
});
export const LeaveRoomMessageSchema = z.object({
    type: z.literal('leave_room'),
});
export const PlayerInputMessageSchema = z.object({
    type: z.literal('player_input'),
    sequence: z.number().int().nonnegative(),
    throttle: z.number().min(-1).max(1),
    steer: z.number().min(-1).max(1),
    brake: z.boolean().optional().default(false),
    turretYaw: z.number(),
    gunPitch: z.number(),
});
export const FireRequestMessageSchema = z.object({
    type: z.literal('fire_request'),
    sequence: z.number().int().nonnegative(),
});
export const PingMessageSchema = z.object({
    type: z.literal('ping'),
    clientTimestamp: z.number(),
});
export const SetReadyMessageSchema = z.object({
    type: z.literal('set_ready'),
    isReady: z.boolean(),
});
export const SetTeamMessageSchema = z.object({
    type: z.literal('set_team'),
    team: z.enum(['red', 'blue', 'none']),
});
export const SelectTankMessageSchema = z.object({
    type: z.literal('select_tank'),
    tankClassId: z.string(),
});
export const SendChatMessageSchema = z.object({
    type: z.literal('send_chat'),
    message: z.string().trim().min(1).max(200),
});
export const StartMatchMessageSchema = z.object({
    type: z.literal('start_match'),
});
export const UpdateRoomSettingsMessageSchema = z.object({
    type: z.literal('update_room_settings'),
    mapId: z.string().optional(),
    mode: z.enum(['ffa', 'team_deathmatch', 'domination']).optional(),
    botCount: z.number().int().min(0).max(8).optional(),
});
export const ClientMessageSchema = z.discriminatedUnion('type', [
    JoinRoomMessageSchema,
    LeaveRoomMessageSchema,
    PlayerInputMessageSchema,
    FireRequestMessageSchema,
    PingMessageSchema,
    SetReadyMessageSchema,
    SetTeamMessageSchema,
    SelectTankMessageSchema,
    SendChatMessageSchema,
    StartMatchMessageSchema,
    UpdateRoomSettingsMessageSchema,
]);
// Helper to safely parse client messages
export function parseClientMessage(raw) {
    try {
        let parsedJson = raw;
        if (typeof raw === 'string') {
            parsedJson = JSON.parse(raw);
        }
        const result = ClientMessageSchema.safeParse(parsedJson);
        if (result.success) {
            return { success: true, data: result.data };
        }
        return { success: false, error: result.error.errors.map(e => `${e.path.join('.')}: ${e.message}`).join(', ') };
    }
    catch (err) {
        return { success: false, error: `Invalid JSON payload: ${err.message}` };
    }
}
// Auth validation schemas
export const registerSchema = z.object({
    username: z
        .string()
        .trim()
        .min(3, 'Tên người dùng tối thiểu 3 ký tự')
        .max(20, 'Tên người dùng tối đa 20 ký tự')
        .regex(/^[a-zA-Z0-9_]+$/, 'Tên người dùng chỉ được chứa chữ cái, chữ số và dấu gạch dưới'),
    email: z.string().trim().email('Địa chỉ email không hợp lệ'),
    password: z.string().min(6, 'Mật khẩu phải có ít nhất 6 ký tự').max(64, 'Mật khẩu tối đa 64 ký tự'),
});
export const loginSchema = z.object({
    usernameOrEmail: z.string().trim().min(1, 'Vui lòng nhập tên tài khoản hoặc email'),
    password: z.string().min(1, 'Vui lòng nhập mật khẩu'),
});
//# sourceMappingURL=protocol.js.map